// extracted by mini-css-extract-plugin
export default {"container":"page_container-module__container--3RvEG"};